/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chunky_Crazy_Clownfish_BreatheInputs */

const fr_chunky_crazy_clownfish_breathe = /** @type {(inputs: Chunky_Crazy_Clownfish_BreatheInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous êtes sur le point de supprimer le rôle, êtes-vous certains ?`)
};

/**

* @param {Chunky_Crazy_Clownfish_BreatheInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const chunky_crazy_clownfish_breathe = /** @type {((inputs?: Chunky_Crazy_Clownfish_BreatheInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chunky_Crazy_Clownfish_BreatheInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_chunky_crazy_clownfish_breathe(inputs)
});